import {DateTime} from 'luxon';

/**
 * Formats an ISO date string (e.g. '2026-10-30') as a medium localized date.
 * Invalid values are returned unchanged.
 * @param {string} value
 * @returns {string}
 */
export function formatPublicDate(value) {
  const date = DateTime.fromISO(value);
  return date.isValid ? date.toLocaleString(DateTime.DATE_MED) : value;
}

/**
 * Formats the `date[]` array returned by the public project/event endpoints.
 * Falsy entries (nulls) are ignored.
 * @param {Array<string|null>} dates
 * @param {string} [separator]
 * @returns {string} formatted dates, or '—' when there are none
 */
export function formatPublicDates(dates, separator = ' – ') {
  const present = (dates || []).filter(Boolean);
  return present.length > 0 ? present.map(formatPublicDate).join(separator) : '—';
}

/**
 * Joins labels with "or": single value as-is, two items with just "or"
 * (no comma), three or more items with an Oxford comma before "or".
 * @param {Array<string>} labels
 * @returns {string}
 */
export function joinWithOr(labels) {
  if (!labels || labels.length === 0) return '';
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} or ${labels[1]}`;
  return `${labels.slice(0, -1).join(', ')}, or ${labels[labels.length - 1]}`;
}

/**
 * @param {Array<string>} values
 * @returns {string} 'A | B', or '—' when empty
 */
export function joinList(values) {
  return values && values.length > 0 ? values.join(' | ') : '—';
}
